<template>
  <div>
    <div v-if="!loading">
      <table class="
            pt-2
            table table-sm table-responsive
            border-bottom
            max-w-full
            divide-y divide-gray-200
            rounded
            col-sm-12
          ">
        <thead class="table-active">
          <tr>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2">
              Fecha y hora
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2">
              Usuario
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2">
              Acción
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2">
              Registro afectado
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-if="!logs.length">
            <td colspan="4" class="px-6 py-3 text-sm text-gray-500 text-center">
              Sin cambios registrados todavía.
            </td>
          </tr>
          <template v-for="item in logs">
            <tr :key="item.id">
              <td class="px-6 text-sm text-gray-500 mx-2">
                {{ dateConvert(item.created_at) }}
              </td>
              <td class="px-6 text-sm text-gray-500 mx-2">
                {{ causerLabel(item) }}
              </td>
              <td class="px-6 text-sm text-gray-500 mx-2">
                <span :class="`badge badge-soft-${eventVariant(item.event)}`">
                  {{ eventLabel(item.event) }}
                </span>
              </td>
              <td class="px-6 text-sm text-gray-500 mx-2">
                {{ subjectLabel(item) }}
                <a href="javascript:void(0)" class="ml-2" @click="toggleDetail(item.id)">
                  {{ expanded.includes(item.id) ? 'Ocultar detalle' : 'Ver detalle' }}
                </a>
              </td>
            </tr>
            <tr v-if="expanded.includes(item.id)" :key="`detail-${item.id}`">
              <td colspan="4" class="px-6 py-2 bg-light">
                <div v-if="!changesList(item).length" class="text-muted small">
                  Sin campos con detalle para mostrar.
                </div>
                <table v-else class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Campo</th>
                      <th v-if="item.event === 'updated'">Valor anterior</th>
                      <th>{{ item.event === 'updated' ? 'Valor nuevo' : 'Valor' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(c, idx) in changesList(item)" :key="idx">
                      <td>{{ c.campo }}</td>
                      <td v-if="item.event === 'updated'">{{ c.anterior }}</td>
                      <td>{{ item.event === 'updated' ? c.nuevo : c.valor }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
    <Pagination @loading="(load) => (loading = load)" ref="paginator" @fetch="(items) => (logs = items)" />
  </div>
</template>

<script>
import Pagination from "./AuditLogPagination"
import { dateFormat } from "@/utils/helpers/format"

// Columnas propias de Eloquent/timestamps que no aportan al detalle del cambio.
const CAMPOS_RUIDO = ['id', 'created_at', 'updated_at', 'deleted_at']

export default {
  components: { Pagination },
  data() {
    return {
      logs: [],
      loading: true,
      expanded: [],
    };
  },
  methods: {
    dateConvert(date) {
      return date ? dateFormat(date) : '-'
    },
    causerLabel(item) {
      return item.causer_id ? `Usuario #${item.causer_id}` : 'Sistema'
    },
    eventLabel(event) {
      const labels = { created: 'Creó', updated: 'Editó', deleted: 'Eliminó' }
      return labels[event] || event
    },
    eventVariant(event) {
      const variants = { created: 'success', updated: 'warning', deleted: 'danger' }
      return variants[event] || 'secondary'
    },
    subjectLabel(item) {
      return item.subject_display || `${item.subject_label || 'Registro'} #${item.subject_id}`
    },
    toggleDetail(id) {
      const idx = this.expanded.indexOf(id)
      if (idx === -1) {
        this.expanded.push(id)
      } else {
        this.expanded.splice(idx, 1)
      }
    },
    formatValue(v) {
      if (v === null || v === undefined || v === '') return '(vacío)'
      if (typeof v === 'object') return JSON.stringify(v)
      return String(v)
    },
    changesList(item) {
      const props = item.properties || {}

      if (item.event === 'created') {
        return Object.entries(props.new || {})
          .filter(([campo]) => !CAMPOS_RUIDO.includes(campo))
          .map(([campo, valor]) => ({ campo, valor: this.formatValue(valor) }))
      }

      if (item.event === 'deleted') {
        return Object.entries(props.old || {})
          .filter(([campo]) => !CAMPOS_RUIDO.includes(campo))
          .map(([campo, valor]) => ({ campo, valor: this.formatValue(valor) }))
      }

      const anteriores = props.old || {}
      const nuevos = props.new || {}
      return Object.keys(nuevos)
        .filter((campo) => !CAMPOS_RUIDO.includes(campo))
        .map((campo) => ({
          campo,
          anterior: this.formatValue(anteriores[campo]),
          nuevo: this.formatValue(nuevos[campo]),
        }))
    },
  },
};
</script>
